import { render, staticRenderFns } from "./SupplierOnboardingContacts.vue?vue&type=template&id=b671237a&"
import script from "./SupplierOnboardingContacts.vue?vue&type=script&lang=js&"
export * from "./SupplierOnboardingContacts.vue?vue&type=script&lang=js&"
import style0 from "./SupplierOnboardingContacts.vue?vue&type=style&index=0&id=b671237a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports